<template>
  <div class="payment-form">
    <div>
      <div>
        <div v-show="total > 0">
          <select-payment-gateway
            v-model="payment_method"
            :is-recurring="isRecurring"
          />

          <credit-card-input
            v-show="payment_method === 'visa'"
            ref="card"
          />
          <wire-transfer-input
            v-show="payment_method === 'wiretransfer'"
            ref="wireInput"
            v-model="image"
          />
        </div>
        <div
          v-if="showRedirect"
          class="redirect-note text-secondary"
          v-html="$t('payment.redirect-note', [payment_method])"
        />
      </div>

      <div v-if="!isUpgrade && total > 0">
        <coupon-input
          v-model="coupon"
          :current-package="currentPackage.slug"
          :target-package="targetPackages"
        />
      </div>

      <purchase-summary-list
        :discount="discountedValue"
        :subtotal="subtotal"
        :total="total"
        :upgrade-amount="upgradeAmount"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import SelectPaymentGateway from '@/views/admin/purchase/components/SelectPaymentGateway'
import CreditCardInput from '@/views/admin/purchase/components/CreditCardInput'
import WireTransferInput from '@/views/admin/purchase/components/WireTransferInput'
import CouponInput from '@/views/admin/purchase/components/CouponInput'
import PurchaseSummaryList from '@/views/admin/purchase/components/PurchaseSummaryList'
import SubscriptionAPIs from '@/API/subscription/subscription-api'
import PurchaseResponseMixin from '@/mixins/purchase-response-mixin'

export default {
  name: 'PaymentForm',
  components: {
    PurchaseSummaryList,
    CouponInput,
    WireTransferInput,
    CreditCardInput,
    SelectPaymentGateway,
  },
  mixins: [PurchaseResponseMixin],
  computed: {
    ...mapFields('purchase', ['coupon', 'payment_method', 'image', 'token', 'plan', 'features', 'source']),
    ...mapGetters({
      currentPackage: 'subscription/currentPackage',
      total: 'purchase/total',
      discount: 'purchase/discount',
      discountedValue: 'purchase/discountedValue',
      subtotal: 'purchase/subtotal',
      isUpgrade: 'purchase/isUpgrade',
      upgradeAmount: 'purchase/upgradeAmount',
      subscribeToFreeOnly: 'purchase/subscribeToFreeOnly',
    }),
    showRedirect() {
      return this.payment_method && !['visa', 'fawry', 'wiretransfer'].includes(this.payment_method)
    },
    targetPackages() {
      return this.plan?.slug || this.features.map(feature => feature.slug).join(',') || ''
    },
    isRecurring() {
      return !this.features.length
    },
  },
  methods: {
    async submit() {
      if (this.subscribeToFreeOnly) {
        await SubscriptionAPIs.subscribeToFreePlan()
        await this.$store.dispatch('subscription/FETCH_SUBSCRIPTION_DETAILS', true)
        await this.$router.push({ name: 'billing:manage-subscription' })
        return ''
      }

      if (this.total > 0) {
        if (this.payment_method === 'visa') {
          this.token = await this.getCardToken()
        }
        if (this.payment_method === 'wiretransfer' && this.$refs.wireInput && !(await this.$refs.wireInput.validate())) {
          throw new Error(this.$tc('errors.field-invalid', 1))
        }
      }

      let routeName = this.$route.name
      if (routeName === 'billing:plans') {
        routeName = 'billing:manage-subscription'
      }

      const routeQuery = this.$route.query ?? {}
      delete routeQuery.reactive

      const route = { name: routeName, query: routeQuery }
      const purchaseResponse = await this.$store.dispatch('purchase/PURCHASE', route)
      return this.handlePurchaseResponse(purchaseResponse, this.source)
    },
    async getCardToken() {
      return new Promise((resolve, reject) => {
        if (!this.$refs.card) reject(new Error('No card element found'))

        console.log('generate token')
        this.$refs.card
          .createToken()
          .then(token => {
            console.log('token', token)
            resolve(token)
          })
          .catch(err => reject(err))
          .finally(() => console.log('finish'))
      })
    },
  },
}
</script>

<style lang="scss">
.payment-form {
  .redirect-note {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 30px;
    margin-top: 26px;
    padding: 0 5px;
  }

}
</style>
